import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";
import AutoQuery from "servicestack/auto-query/auto-query";
import Product from "emun.shopping/product.model";

export default class OrderMultiAddController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.config = cartConfig;
		$ctrl.order = Object.assign({}, options.model, options.order);
		$ctrl.product = options.product;
		$ctrl.title = "Add " + options.product.id;
		$ctrl.subTitle = "Variations";
		$ctrl.item = options.cartItem;
		$ctrl.message = options.message || "This product is available in other colors/sizes.  Would you like to add some more?";
		console.debug("cartConfig.multiAddOptionsDefaultQty", cartConfig.multiAddOptionsDefaultQty);
		if (cartConfig.multiAddOptionsDefaultQty) {
			$ctrl.product.quantity = $ctrl.item.quantity;
    }
		
		$ctrl.results = [];
		$ctrl.colorOptionsQuery = new AutoQuery({
			url: `QueryProducts.json?src=OptionLink`,
			criteria: {
				cartId: this.$cart.id
			},
			tagCriteria: {
				OptionLink: $ctrl.product.tags.OptionLink
			},
			autoLoad: true,
			onLoaded: args => ($ctrl.parts = Product.map(args.results))
		});
	}
	save() {
		const $ctrl = this;
		$ctrl.lines = [];
		$ctrl.bus.validationErrors = [];


		let result = $ctrl.results.reduce((accumulatorPromise, part) => {
			return accumulatorPromise.then(() => {
				if (part.qty > 0) {
					var item = part.isInCart() ? $ctrl.$cart.itemIndex[part.id] : {};
					item.qtyPurchased = item.quantity = part.qty;
					item.notes = part.notes;
					if (part.priceOverride !== part.price) {
						item.priceOverride = part.priceOverride;
					}
					return part.isInCart() ? $ctrl.$cart.changeOptions(item, part) : $ctrl.$cart.addItem(item, part, true, '', true);
				}
			});
		}, Promise.resolve());
		result.then(() => {
			$ctrl.$cart.load();
		});


		//$ctrl.results.forEach(function (part, index) {
		//	if (part.qty > 0) {
		//		var item = {};
		//		item.qtyPurchased = item.quantity = part.qty;
		//		item.product = part;
		//		$ctrl.lines.push(item);
		//	}
		//});

		//if ($ctrl.lines.length > 0) {
		//	$ctrl.$cart.addMultipleItems($ctrl.lines).then(() => {
		//		$ctrl.$cart.load($ctrl.$cart.id);
		//		$ctrl.$close();
		//	});
		//}
	}
}
